import { render } from "./AddGroupForm.vue?vue&type=template&id=6e811c28&ts=true"
import script from "./AddGroupForm.vue?vue&type=script&lang=ts"
export * from "./AddGroupForm.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__